document.addEventListener('change', function (e) {
  var select = e.target;
  if (!select.classList.contains('tjbc-card-variant-select')) return;
  e.stopPropagation();

  var container = select.closest('.tjbc-card-variant-selects');
  if (!container) return;

  var dataEl = container.querySelector('.tjbc-variant-data');
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (err) {
    return;
  }

  var selects = container.querySelectorAll('.tjbc-card-variant-select');
  var selectedOptions = Array.from(selects).map(function (s) { return s.value; });

  var matchingVariant = variants.find(function (v) {
    return selectedOptions.every(function (val, i) {
      return v['option' + (i + 1)] === val;
    });
  });

  if (!matchingVariant && selectedOptions.length > 1) {
    matchingVariant = variants.find(function (v) { return v.option1 === selectedOptions[0]; });
  }

  if (!matchingVariant) return;

  var productCard = container.closest('product-card');
  if (!productCard) return;

  // --- Update card link ---
  var link = productCard.querySelector('.product-card__link');
  var productPath = null;
  if (link && link.href) {
    try {
      var linkUrl = new URL(link.href, window.location.origin);
      productPath = linkUrl.pathname;
      linkUrl.searchParams.set('variant', matchingVariant.id);
      link.href = linkUrl.toString();
    } catch (urlErr) {}
  }

  // --- Update price via Section Rendering API ---
  // Fetch the server-rendered price HTML so Shopify formats the money correctly.
  var priceContainer = productCard.querySelector('[ref="priceContainer"]');
  if (priceContainer && productPath) {
    fetch(productPath + '?section_id=section-rendering-product-card&variant=' + matchingVariant.id)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newPrice = doc.querySelector('[ref="priceContainer"]');
        if (newPrice) priceContainer.replaceWith(newPrice);
      })
      .catch(function () {});
  }

  // --- Swap card image ---
  // slideshow-slide[hidden]:not([reveal]) { display: none } — must set/remove [hidden] directly.
  var mediaId = matchingVariant.featured_media && matchingVariant.featured_media.id;
  var slideshow = productCard.querySelector('slideshow-component[ref="slideshow"]');
  if (!slideshow) return;

  var allSlides = slideshow.querySelectorAll('slideshow-slide');

  if (mediaId) {
    var targetSlide = null;
    allSlides.forEach(function (s) {
      if (s.getAttribute('slide-id') == String(mediaId)) {
        targetSlide = s;
      } else {
        s.setAttribute('hidden', '');
        s.removeAttribute('reveal');
        s.setAttribute('aria-hidden', 'true');
      }
    });
    if (targetSlide) {
      targetSlide.removeAttribute('hidden');
      targetSlide.setAttribute('reveal', '');
      targetSlide.setAttribute('aria-hidden', 'false');
    }
  } else {
    // Variant has no dedicated media — restore the first (featured) slide
    allSlides.forEach(function (s, i) {
      if (i === 0) {
        s.removeAttribute('hidden');
        s.removeAttribute('reveal');
        s.setAttribute('aria-hidden', 'false');
      } else {
        s.setAttribute('hidden', '');
        s.removeAttribute('reveal');
        s.setAttribute('aria-hidden', 'true');
      }
    });
  }
});
